import { Table } from 'rsuite';
import styled from 'styled-components';

export const Content = styled.div`
  width: 100%;
  align-items: center;
  justify-content: center;
`;

export const InputWrapper = styled.div`
  width: 100%;
  display: flex;
`;

export const StyledTable = styled(Table)`
  align-items: center;
  justify-content: center;
  border-color: ${({ theme }) => theme.colors.background};
  background-color: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.textSecondary};
  overflow-y: auto;
`;

export const AvalilableText = styled.span`
  font-weight: 500;
  font-size: 14px;
  border-radius: 4px;
  color: ${({ available, theme }) =>
    available
      ? theme.colors.success
      : theme.colors.error || 'rgba(250, 90, 90, 1)'};
`;
